// extracted by mini-css-extract-plugin
export default {"result":"ResultsTable_result__F8NqB"};